import { render, staticRenderFns } from "./RPBaseStatCard.vue?vue&type=template&id=347784bc&"
import script from "./RPBaseStatCard.vue?vue&type=script&lang=js&"
export * from "./RPBaseStatCard.vue?vue&type=script&lang=js&"
import style0 from "./RPBaseStatCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports